import axios from 'axios';

//setting access token header if user is already logged in.
let user = JSON.parse(sessionStorage.getItem('user'));
const token = user && user['x-access-token'] ? user['x-access-token'] : "";

export default axios.create({
	headers: {'x-access-token': token}
});